var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_271",
    "data-name": "\\uADF8\\uB8F9 271",
    transform: "translate(-601 -398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 32,
    height: 32,
    transform: "translate(601 398)",
    fill: "#ff2727",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_1",
    "data-name": "\\uBE7C\\uAE30 1",
    d: "M10-103A10.012,10.012,0,0,1,0-113a10.011,10.011,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.012,10.012,0,0,1,10-103Zm-1.873-9.22a2.813,2.813,0,0,0-2.81,2.81v.7a1.172,1.172,0,0,0,1.17,1.171h7.025a1.172,1.172,0,0,0,1.17-1.171v-.7a2.813,2.813,0,0,0-2.81-2.81h-.2a3.827,3.827,0,0,1-1.67.39,3.845,3.845,0,0,1-1.67-.39ZM14.683-113a1.554,1.554,0,0,0-1.1.454,3.586,3.586,0,0,1,1.832,2.668h1.61a.781.781,0,0,0,.78-.78v-.78A1.563,1.563,0,0,0,16.244-113ZM3.756-113A1.563,1.563,0,0,0,2.2-111.439v.78a.781.781,0,0,0,.78.78H4.583a3.6,3.6,0,0,1,1.834-2.668,1.551,1.551,0,0,0-1.1-.454ZM10-118.463a2.735,2.735,0,0,0-2.732,2.731A2.735,2.735,0,0,0,10-113a2.735,2.735,0,0,0,2.731-2.731A2.735,2.735,0,0,0,10-118.463Zm5.464,1.561a1.563,1.563,0,0,0-1.561,1.562,1.563,1.563,0,0,0,1.561,1.561,1.562,1.562,0,0,0,1.561-1.561A1.563,1.563,0,0,0,15.464-116.9Zm-10.928,0a1.563,1.563,0,0,0-1.561,1.562,1.562,1.562,0,0,0,1.561,1.561A1.563,1.563,0,0,0,6.1-115.341,1.563,1.563,0,0,0,4.536-116.9Z",
    transform: "translate(607 527)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ab05519a6d0c048c7ea7ba7faf9379dc.svg";
export { ForwardRef as ReactComponent };